<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create Fixed Deposit</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreateFixedDepositCard />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../../router/layouts/main";
import PageHeader from "../../../components/AppComponents/page-header";
import CreateFixedDepositCard from "@/components/Kleyton/Cards/Investment/FixedDeposit/CreateFixedDepositCard";

export default {
  page: {
    title: "Create Fixed Deposit",
    meta: [{ name: "Create Fixed Deposit", content: window.__env.app.description }]
  },

  components: {
    CreateFixedDepositCard,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "CreateFixedDeposit",
      title: "Create Fixed Deposit",
      items: [
        {
          text: "Investment",
          href: "/"
        },
        {
          text: "Create Fixed Deposit",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
